var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 794"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 85",
    cx: 9.66675,
    cy: 9.16162,
    r: 5.09717,
    stroke: "#444444"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1042"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 31",
    d: "M9.97205 14.208C9.97205 14.208 11.8151 13.1621 11.8151 9.16165C11.8151 5.16118 9.97205 4.1153 9.97205 4.1153",
    stroke: "#444444",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 32",
    d: "M9.36133 14.208C9.36133 14.208 7.51829 13.1621 7.51829 9.16165C7.51829 5.16118 9.36133 4.1153 9.36133 4.1153",
    stroke: "#444444",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line 54",
    x1: 4.86914,
    y1: 9.37305,
    x2: 14.4643,
    y2: 9.37305,
    stroke: "#444444",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.f1bee0dbb7687c14a9a6f855f2bff672.svg";
export { ForwardRef as ReactComponent };